import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel } from "./carousel/carousel";
import styles from "./explore-our-evs.module.css";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
import { useLatestVehicles } from "libs/landing/ui/shared/src/lib/hooks/use-latest-vehicles";
import { Primary } from "@cinch-labs/design-system";
export const ExploreEvs = ()=>{
    const { data , error  } = useLatestVehicles({
        fuelType: "Electric",
        numberOfVehicles: 6
    });
    if (!data || error) {
        console.error(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    const handleClick = ()=>{
        window.open("https://www.cinch.co.uk/used-cars/electric-fuel-type", "_blank");
    };
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: sharedStyles.heading,
                children: "Explore our EVs"
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                carouselName: "electric-vehicles-carousel",
                vehicles: data.vehicleListings
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.buttonWrapper,
                children: /*#__PURE__*/ _jsx(Primary, {
                    type: "submit",
                    "data-testid": "ev-button",
                    onClick: handleClick,
                    children: "Browse our electric cars"
                })
            })
        ]
    });
};
